import { SvgIcon } from '@mui/material';
import { motion } from 'motion/react';
import { forwardRef } from 'react';

import type { AnimatedIconProps, AnimeatableIconRef } from './types';
import { pathVariants } from './types';
import { useAnimatedIcon } from './useAnimatedIcon';

const CreditCardIcon = forwardRef<AnimeatableIconRef, AnimatedIconProps>(
  ({ size = 28, strokeWidth = 2, titleAccess, color, fontSize }, ref) => {
    const controls = useAnimatedIcon(ref);

    return (
      <SvgIcon
        titleAccess={titleAccess}
        color={color}
        fontSize={fontSize}
        sx={fontSize ? undefined : { width: size, height: size }}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <motion.rect
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={0}
            width="20"
            height="14"
            x="2"
            y="5"
            rx="2"
          />
          <motion.line
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={1}
            x1="2"
            x2="22"
            y1="10"
            y2="10"
          />
        </svg>
      </SvgIcon>
    );
  }
);

CreditCardIcon.displayName = 'CreditCardIcon';

export { CreditCardIcon };
